import { useEffect, useMemo, useState } from 'react'

import { GetDynamicData as BLGetDynamicData } from './../../../utilities/BL/Admin/Dashboard/Dynamics'
import { SendQuestionToUsers as BLSendQuestionToUsers, GetAllResults, ResetCurrentDynamic as BLResetCurrentDynamic, SendResultsToScreen, GetAllRiddleResults as BLGetAllRiddleResults, SendRiddleResultsToScreen as BLSendRiddleResultsToScreen, SendRiddleQuestionToUsers as BLSendRiddleQuestionToUsers, ShowItemOnScreen as BLShowItemOnScreen, ShowRiddleFrontPage as BLShowRiddleFrontPage } from './../../../utilities/BL/Zones'

//import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, PieChart, Pie } from 'recharts'
//import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from 'recharts'
//const barColors = ['#f44336', '#2196f3', '#4caf50', '#ff9800', '#9c27b0', '#00bcd4', '#e91e63', '#795548']
//const PieColors = ['#ff6384', '#36a2eb', '#ffce56', '#4caf50', '#9c27b0', '#00bcd4']

import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts'
import { SecondaryBase } from './../Commons/SecondaryBase'

import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'
import { Dropdown } from 'bootstrap/dist/js/bootstrap.bundle.min'


const barColors = ['#f44336', '#2196f3', '#4caf50', '#ff9800', '#9c27b0', '#00bcd4', '#e91e63', '#795548']


const GeneralResultsChart = ({ data }) => {
    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data}>
                <XAxis dataKey="text" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="points" fill="#8884d8">
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={barColors[index % barColors.length]} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}

const BarResultsByQuestion = ({ questionId, pointsByZone, results }) => {
    // Mapeamos zonas con puntos (si no tiene puntos, no se incluye)
    // const data = results
    //     .map(zone => {
    //         const key = zone.name.toLowerCase().trim()
    //         const points = pointsByZone[key]
    //         return points ? { name: zone.text, points } : null
    //     })
    //     .filter(Boolean)
    
    // const data = results
    // .map(zone => {
    //     const key = zone.key
    //     const points = pointsByZone[key]
    //     return points ? { name: zone.text, points } : null
    // })
    // .filter(Boolean)

    const data = results
        .map(zone => {
            const key = zone.key // ahora viene de .text.toLowerCase()
            const points = pointsByZone[key]
            return points ? { name: zone.text, points } : null
        })
        .filter(Boolean)


    return (
        <div className="mb-5 pb-4">
            <p className="fw-bold text-center">Pregunta {questionId}</p>

            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="points">
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={barColors[index % barColors.length]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            {/* <p className="fw-semibold mt-3">Resultados por zona:</p> */}
            {data.map((zone, index) => (
                <p key={index} className="ms-3">{zone.name}: {zone.points}</p>
            ))}
        </div>
    )
}



const Riddle = ({ getOutOfTheDynamic }) => {
    const { showMessage } = useFloatMessage()

    const [quizz,setQuizz] = useState([])
    const [currentIndex,setCurrentIndex] = useState(0)
    const [gameStarted,setGameStarted] = useState(false)
    const [isItemVisible,setIsItemVisible] = useState(true)
    const [isWorking,setIsWorking] = useState(false)
    
    const [showResults,setShowResults] = useState(false)
    const [results,setResults] = useState(null)
    const [questionsResults,setQuestionsResults] = useState(null)
    const [detailedResults,setDetailedResults] = useState(null)

    const [errorMessage,setErrorMessage] = useState(null)


    const ReturnToDashboard = async () => {
        try {
            await BLResetCurrentDynamic()
            getOutOfTheDynamic()
        } catch (error) {
            
        }
    }

    const ShowResultsView = async () => {
        try {
            setIsWorking(true)
            setErrorMessage(null)
            
            const response = await BLGetAllRiddleResults()
            
            if (!response.success) {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: 'No fue posible obtener los resultados de las adivinanzas. Inténtalo nuevamente o inténtalo más tarde.'
                })
                setErrorMessage('No fue posible obtener los resultados de las adivinanzas. Inténtalo nuevamente o inténtalo más tarde.')
                console.warn("⚠️ No se pudo obtener los resultados:", response.message)
                return
            }
            
            const resultsByQuestion = response.data || []
            if (resultsByQuestion.length === 0) {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: 'Aún no hay resultados de las adivinanzas. Inténtalo nuevamente o inténtalo más tarde.'
                })
                setErrorMessage('Aún no hay resultados de las adivinanzas. Inténtalo nuevamente o inténtalo más tarde.')
                console.warn("⚠️ No se encontraron resultados.")
                return
            }

            setDetailedResults(resultsByQuestion)

            // Lista fija de zonas con su estado inicial
            const zonesTemplate = [
                { name: "Zona Laboratorio Tequis", text: "Laboratorio Tequis", points: 0, show: false },
                { name: "Zona Canels", text: "Canels", points: 0, show: false },
                { name: "Zona Seguros El Potosí", text: "Seguros El Potosí", points: 0, show: false },
                { name: "Zona Red Cola", text: "Red Cola", points: 0, show: false },
                { name: "Zona Tecate", text: "Tecate", points: 0, show: false },
                { name: "Zona Moctezuma", text: "Moctezuma", points: 0, show: false },
                { name: "Zona Nissan", text: "Nissan", points: 0, show: false },
                { name: "Zona Mobil", text: "Mobil", points: 0, show: false },
                { name: "Zona Lounge Ron Potosí", text: "Lounge Ron Potosí", points: 0, show: false },
                { name: "Zona Azul", text: "Azul", points: 0, show: false },
                { name: "Zona Oro", text: "Oro", points: 0, show: false },
                // Temporales Escuelas ADSL
                { name: "Team Lucho", text: "Lucho", points: 0, show: false },
                { name: "Team Tunita", text: "Tunita", points: 0, show: false }
            ]

            // Inicializamos totales acumulados
            const totalPointsByZone = {}

            zonesTemplate.forEach(zone => {
                totalPointsByZone[zone.text.toLowerCase()] = 0
            })

            const questionsBreakdown = resultsByQuestion.map(result => {
                const questionId = result.id
                const pointsPerZone = result.calculatedPointsByZone || {}
                const normalizedPerQuestion = {}

                Object.entries(pointsPerZone).forEach(([zoneName, pts]) => {
                    const key = zoneName.toLowerCase().trim()

                    if (totalPointsByZone.hasOwnProperty(key)) {
                        totalPointsByZone[key] += pts
                    } else {
                        totalPointsByZone[key] = pts
                    }

                    normalizedPerQuestion[key] = pts
                })

                return {
                    questionId,
                    pointsByZone: normalizedPerQuestion
                }
            })
            
            const finalResultsPerZone = zonesTemplate.map(zone => {
                const key = zone.text.toLowerCase()
                const points = totalPointsByZone[key] || 0

                return {
                    ...zone,
                    key,
                    points,
                    show: points > 0
                }
            })
            
            // Guardamos en estado (ajusta según tu lógica)
            //console.log('finalResultsPerZone: ' + JSON.stringify(finalResultsPerZone))
            setResults(finalResultsPerZone)
            //console.log('questionsBreakdown: ' + JSON.stringify(questionsBreakdown))
            setQuestionsResults(questionsBreakdown) // puedes usar esto en otra vista
            //console.log('detailedResults: ' + JSON.stringify(resultsByQuestion))
            setDetailedResults(resultsByQuestion)
            setShowResults(true)
            //debugger
            // Enviar resultados a la pantalla
            const responseShowResults = await BLSendRiddleResultsToScreen()
            
            if (responseShowResults.success) {
                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: 'Info enviada a la pantalla correctamente'
                })
                //console.log("Info enviada a la pantalla correctamente")
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
                //console.log(response.message)
            }
        } catch (error) {
            showMessage({
                type: MESSAGE_TYPE.BAD,
                text: 'Ocurrió un error al intentar mostrar los resultados. Inténtalo nuevamente o intenta más tarde. Error: ' + error
            })
            //console.error("❌ Error al mostrar resultados:", error)
            setErrorMessage("Ocurrió un error al intentar mostrar los resultados. Intenta nuevamente. Error: " + error)
        } finally {
            setIsWorking(false)
        }
    }

    const SendRiddleQuestionToUsers = async (question) => {
        try {
            const response = await BLSendRiddleQuestionToUsers(question)
            
            if (response.success) {
                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: 'Pregunta enviada a los Aficionados y a la Pantalla'
                })
                //console.log('Pregunta enviada a los aficionados y pantalla')
                return { success: true, data: null }
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
                //console.log(response.message)
                return { success: false, message: '' }
            }
        } catch (error) {
            
        }
    }

    const handleOpenRoomAndShowQR = async () => {
        try {
            setIsWorking(true)
            showMessage({ type: MESSAGE_TYPE.INFO, text: "Limpiando estadio y mostrando QR..." })

            await BLResetCurrentDynamic()

            await fetch(`${process.env.REACT_APP_API_URL}Admin/sendWelcome`, {
                method: 'POST'
            })

            showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Sala abierta con éxito. QR en pantalla." })
        } catch (error) {
            showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al limpiar dinámica o al enviar el QR." })
        } finally {
            setIsWorking(false)
        }
    }

    const handleShowFrontPage = async () => {
        try {
            setIsWorking(true)
            showMessage({ type: MESSAGE_TYPE.INFO, text: "Enviando portada a pantalla..." })

            const response = await BLShowRiddleFrontPage()

            if (response.success) {
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Portada de Adivina adivinador en pantalla." })
            } else {
                showMessage({ type: MESSAGE_TYPE.BAD, text: response.message || "Error al mostrar la portada." })
            }
        } catch (error) {
            showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al mostrar la portada." })
        } finally {
            setIsWorking(false)
        }
    }

    const StartGame = async () => {
        try {
            setIsWorking(true)
            setIsItemVisible(false)
            // Tomar la primera pregunta
            setCurrentIndex(0)
            const firstQuestion = quizz[0]
            
            const response = await SendRiddleQuestionToUsers(firstQuestion)
            
            if (response.success) {
                setGameStarted(true)
                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: 'Partida iniciada'
                })
                //console.log('Juego iniciado')
            } else {
                setGameStarted(false)
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message || 'Error al iniciar la partida'
                })
                //console.log(response.message)
            }
        } catch (error) {
            showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al iniciar la partida" })
        } finally {
            setIsWorking(false)
        }
    }

    const GetQuizData = async () => {
        try {
            const response = await BLGetDynamicData()

            if (response.success) {
                setQuizz(response.data)
                setCurrentIndex(0)
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
                //console.log(response.message)
            }
        } catch (error) {
            
        }
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            
            await GetQuizData()
        } catch (error) {
            
        }
    }

    const handleNext = async () => {
        if (currentIndex < quizz.length - 1) {
            const nextIndex = currentIndex + 1
            const nextQuestion = quizz[nextIndex]

            setCurrentIndex(nextIndex)

            if (gameStarted) {
                const response = await SendRiddleQuestionToUsers(nextQuestion)
                if (!response.success) {
                    showMessage({
                        type: MESSAGE_TYPE.BAD,
                        text: 'No se pudo enviar la siguiente pregunta'
                    })
                    //console.warn('❌ No se pudo enviar la siguiente pregunta')
                }
                setIsItemVisible(false)
            }
        }
    }

    const handlePrev = async () => {
        if (currentIndex > 0) {
            const prevIndex = currentIndex - 1
            const prevQuestion = quizz[prevIndex]

            setCurrentIndex(prevIndex)

            if (gameStarted) {
                const response = await SendRiddleQuestionToUsers(prevQuestion)
                if (!response.success) {
                    showMessage({
                        type: MESSAGE_TYPE.BAD,
                        text: 'No se pudo enviar la pregunta anterior'
                    })
                    //console.warn('❌ No se pudo enviar la pregunta anterior')
                }
                setIsItemVisible(false)
            }
        }
    }

    const ShowItemOnScreen = async(currentQuestion) => {
        try {
            const response = await BLShowItemOnScreen(currentQuestion)
            
            if (response.success) {
                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: 'Mostrando exitosamente en pantalla al elemento que estaba oculto'
                })
                //console.log('Mostrando exitosamente personaje, cosa o elemento que estaba oculto, en pantalla')
                setIsItemVisible(true)
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
                //console.log(response.message)
            }
        } catch (error) {
            console.log('ShowItemOnScreen - Riddle: ' + error)
        }
    }

    /**
     * Utilidad para renderizar <ul> de pares clave:valor de un objeto.
     * - Ordena alfabéticamente por nombre de zona para consistencia visual.
     * - Si el objeto viene null/undefined o vacío, muestra "(sin datos)".
     */
    const KeyValueList = ({ data }) => {
        if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
            return <p>0 respuestas correctas</p>
        }

        const entries = Object.entries(data).sort((a, b) =>
            a[0].localeCompare(b[0], "es", { sensitivity: "base" })
        )

        return (
            <ul>
                {entries.map(([zone, value]) => (
                    <li key={zone}>{zone}: {value}</li>
                ))}
            </ul>
        )
    }

    // 1) Ordenar ascendente por id (defensivo ante tipos/ausencias)
    const Sorted = useMemo(() => {
        if (!Array.isArray(detailedResults)) return []

        return [...detailedResults].sort((a, b) => {
            const idA = typeof a?.id === "number" ? a.id : Number(a?.id) || 0
            const idB = typeof b?.id === "number" ? b.id : Number(b?.id) || 0

            return idA - idB
        })
    }, [detailedResults])

    useEffect(() => {
        LoadPage()
    }, [])

 
    if (!quizz.length) return <p>Cargando...</p>

    const currentQuestion = quizz[currentIndex]


    return (
        <SecondaryBase actionToExecute={ReturnToDashboard}>
            {showResults ? (
                <>
                    <p className="mb-3 fw-bold text-center">Resultados generales</p>

                    <GeneralResultsChart data={results.filter(r => r.show)} />

                    {results.map((result, index) => (
                        result.show && (
                            <p key={index}>{result.text}: {result.points}</p>
                        )
                    ))}

                    <p className="mt-5 pt-5 mb-3 fw-bold text-center">Resultados por pregunta</p>
                    {questionsResults.map((qr, idx) => (
                        <BarResultsByQuestion
                            key={idx}
                            questionId={qr.questionId}
                            pointsByZone={qr.pointsByZone}
                            results={results}
                        />
                    ))}

                    <div className='Riddle__Results__Statistics'>
                        <p className='Riddle__Results__Statistics__Title'>Estadísticas del juego:</p>

                        <div className='Riddle__Results__Statistics__Container'>
                            {Sorted.map((q) => (
                                <div key={q.id} className='Riddle__Results__Statistics__Container__Item'>
                                    <p className='Riddle__Results__Statistics__Title'>Pregunta #{q.id}:</p>

                                    <div className=''>
                                        <p>Usuarios conectados por zona:</p>
                                        <KeyValueList data={q.connectedUsersByZoneAtStart} />
                                    </div>

                                    <div className=''>
                                        <p>Puntos obtenidos por zona:</p>
                                        <KeyValueList data={q.calculatedPointsByZone} />
                                    </div>

                                    <div className=''>
                                        <p>Respuestas correctas por zona:</p>
                                        <KeyValueList data={q.correctAnswersByZone} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* <p className="mt-5 pt-5 mb-3 fw-bold text-center">Resultados por adivinanza</p>
                    {questionsResults.map((qr, idx) => (
                        <BarResultsByQuestion
                            key={idx}
                            questionId={qr.questionId}
                            pointsByZone={qr.pointsByZone}
                            results={results}
                        />
                    ))} */}
                </>
            ) : (
                <>
                    <section className='Riddle'>
                        <p className='Riddle__Title'><i className='bi bi-question-square'></i> Adivina adivinador</p>

                        {gameStarted === true ? (
                            <p className='Riddle__Text--Center'>Mostrando actualmente:</p>
                        ) : (
                            <p className='Riddle__Text--Center'>Adivinanzas que se le mostrarán al aficionado al iniciar:</p>
                        )}

                        <div className='Riddle__Quiz'>
                            {/* Flecha izquierda para escritorio */}
                            <div className='Riddle__Quiz__LeftSection'>
                                {gameStarted === false && currentIndex > 0 && (
                                    <button type='button' onClick={() => handlePrev(currentQuestion)} className='Btn__Adsl--RedOutlineTransparent Riddle__Quiz__LeftSection__Button'>
                                        <i className="bi bi-caret-left-fill"></i> Anterior
                                    </button>
                                )}
                            </div>

                            {/* Pregunta e instrucciones */}
                            <div className="Riddle__Quiz__Questions text-center">
                                <p className="Riddle__Quiz__Questions__Question">Adivinanza {currentIndex + 1} de {quizz.length}</p>

                                <p className="Riddle__Quiz__Questions__Question">Frase:</p>
                                <p className="Riddle__Quiz__Questions__Question">{currentQuestion.instruction}</p>

                                <p className="Riddle__Quiz__Questions__Question mt-4">Imagen por adivinar</p>
                                <div className="Riddle__Quiz__Questions__Options mt-3">
                                    <div className='Riddle__Quiz__Questions__Options__ImageContainer'>
                                        {isItemVisible ? (
                                            <img src={currentQuestion.response.image} className='Riddle__Quiz__Questions__Options__ImageContainer__Image' />
                                        ) : (
                                            <img src={currentQuestion.image} className='Riddle__Quiz__Questions__Options__ImageContainer__Image' />
                                        )}
                                    </div>

                                    <p className="Riddle__Quiz__Questions__Question mt-3">Opciones de respuesta</p>

                                    {currentQuestion.options.map((option, index) => (
                                        <p key={index} className={`${option.isCorrect ? 'Btn__Adsl--Success' : 'Btn__Adsl--RedOutlineTransparent'} Riddle__Quiz__Questions__Options__Buttons`}>{option.text}</p>
                                    ))}
                                </div>
                            </div>

                            {/* Flecha derecha para escritorio */}
                            <div className='Riddle__Quiz__RightSection'>
                                {isItemVisible ? (
                                    currentIndex < quizz.length - 1 && (
                                        <button type='button' onClick={() => handleNext(currentQuestion)} className='Btn__Adsl--RedOutlineTransparent Riddle__Quiz__RightSection__Button'>
                                            Siguiente <i className="bi bi-caret-right-fill"></i>
                                        </button>
                                    )
                                ) : (
                                    <button type='button' onClick={() => ShowItemOnScreen(currentQuestion)} className='Btn__Adsl--RedOutlineTransparent Riddle__Quiz__RightSection__Button'>
                                        Mostrar elemento oculto <i className="bi bi-eye"></i>
                                    </button>
                                )}
                            </div>

                            {/* Flechas para celular */}
                            <div className='Riddle__Quiz__BottomSection'>
                                {gameStarted === false && currentIndex > 0 && (
                                    <button type='button' onClick={() => handlePrev(currentQuestion)} className='Btn__Adsl--RedOutlineTransparent Riddle__Quiz__BottomSection__Button'>
                                        <i className="bi bi-caret-left-fill"></i>
                                    </button>
                                )}
                                {isItemVisible ? (
                                    currentIndex < quizz.length - 1 && (
                                        <button type='button' onClick={() => handleNext(currentQuestion)} className='Btn__Adsl--RedOutlineTransparent Riddle__Quiz__BottomSection__Button'>
                                            <i className="bi bi-caret-right-fill"></i>
                                        </button>
                                    )
                                ) : (
                                    <button type='button' onClick={() => ShowItemOnScreen(currentQuestion)} className='Btn__Adsl--RedOutlineTransparent Riddle__Quiz__RightSection__Button'>
                                        <i className="bi bi-eye"></i>
                                    </button>
                                )}
                            </div>
                        </div>
                    </section>

                    <section className='Riddle__ActionButtons'>
                        <p className='Riddle__ActionButtons__Title text-center'>Controles del administrador</p>
                        
                        {gameStarted === true && (
                            <p className='text-success text-center'><i className="bi bi-play-circle"></i> Juego en proceso</p>
                        )}

                        <div className='Riddle__ActionButtons__Container d-flex flex-column gap-2'>
                            {gameStarted === false && (
                                <>
                                    <button
                                        type='button'
                                        className={`btn btn-danger fw-bold w-100 shadow-sm py-3 ${isWorking ? 'disabled' : ''}`}
                                        onClick={handleOpenRoomAndShowQR}
                                        disabled={isWorking}
                                    >
                                        <i className="bi bi-qr-code"></i> 1. Proyectar código QR en pantalla
                                    </button>

                                    <button
                                        type='button'
                                        className={`btn btn-info fw-bold w-100 shadow-sm py-3 ${isWorking ? 'disabled' : ''}`}
                                        onClick={handleShowFrontPage}
                                        disabled={isWorking}
                                    >
                                        <i className="bi bi-display"></i> 2. Mostrar portada
                                    </button>

                                    <button
                                        type='button'
                                        className={`Btn__Adsl--RedOutlineTransparent w-100 mw-100 m-0 py-3 ${isWorking ? 'disabled' : ''}`}
                                        onClick={() => StartGame(currentQuestion)}
                                        disabled={isWorking}
                                    >
                                        <i className="bi bi-play-circle-fill"></i> 3. Iniciar partida
                                    </button>
                                </>
                            )}
                            {gameStarted === true && (
                                <>
                                    <button
                                        type='button'
                                        className={`Btn__Adsl--RedOutlineTransparent ms-auto me-auto w-100 py-3 ${isWorking ? 'disabled' : ''}`}
                                        onClick={() => ShowResultsView()}
                                        disabled={isWorking}
                                    >
                                        <i className="bi bi-bar-chart"></i> Mostrar resultados en pantalla
                                    </button>
                                    {errorMessage && errorMessage !== '' && ( <p className='text-danger mb-0 text-center small mt-2'>{errorMessage}</p> )}
                                </>
                            )}
                        </div>
                    </section>
                </>
            )}
        </SecondaryBase>
    )
}

export { Riddle };